// extracted by mini-css-extract-plugin
export default {"partners":"partnersPage_partners__J3rIo","partners__list":"partnersPage_partners__list__7b2P9"};